interface Coordinates {
  lat: number;
  lng: number;
}

export class Site {
  id: string;
  name: string;
  siteAccessLevel: string;
  coordinates: Coordinates;
  shortAddress: string;
  effect: number;
  chargerCount: number;
  numberOfAvailableConnectors: number;
  numberOfConnectors: number;
  connectorTypes: string[];
  isRoaming: boolean;

  constructor(data: any) {
    this.id = data.id;
    this.name = data.name;
    this.siteAccessLevel = data.siteAccessLevel;
    this.coordinates = data.coordinates;
    this.shortAddress = data.shortAddress;
    this.effect = data.effect;
    this.chargerCount = data.chargerCount;
    this.numberOfAvailableConnectors = data.numberOfAvailableConnectors;
    this.numberOfConnectors = data.numberOfConnectors;
    this.connectorTypes = data.connectorTypes;
    this.isRoaming = data.isRoaming;
  }
}
